module.exports = __webpack_public_path__ + "static/media/logo-svg-transp.0c476572.svg";